import PropTypes from "prop-types";
import SelectInput from "./SelectInput";
import { useState } from "react";

function MultiSelectInput({
  name,
  options,
  label,
  placeholder,
  error,
  onChange,
}) {
  const [selected, setSelected] = useState([]);
  const [displaySelected, setDisplaySelected] = useState([]);

  const setE = () => {
    const e = {
      target: {
        name: name,
        value: selected,
      }
    }
    return e
  }

  const handleChange = (e) => {
    const isOptionSelected = selected.includes(e.target.value);
    if (!isOptionSelected) {
      const newSelected = selected;
      newSelected.push(e.target.value);
      setSelected(newSelected);
      setDisplaySelected(mapSelected());
      onChange(setE());
    }
  };

  const unselect = (position) => {
    const newSelected = selected;
    newSelected.splice(position, 1);
    setSelected(newSelected);
    setDisplaySelected(mapSelected());
  };

  const mapSelected = () => {
    return selected.map((option, i) => {
      return (
        <p className="p-1 opacity-70 rounded m-1 text-sm border" key={option}>
          {option}
          <span
            onClick={() => {
              unselect(i);
            }}
            className="ml-1 sys_primary cursor-pointer"
          >
            x
          </span>
        </p>
      );
    });
  };

  return (
    <>
      {label && <label className="label mb-2 text-gray-500">{label}</label>}
      <div className="flex my-2 flex-wrap">{displaySelected}</div>
      <SelectInput
        name={name}
        placeholder={placeholder}
        options={options}
        onChange={handleChange}
        error={error}
      />
    </>
  );
}

MultiSelectInput.propTypes = {
  options: PropTypes.array,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  error: PropTypes.object,
};

export default MultiSelectInput;
